import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { firestore } from "../../db/config";

export default function ListUsers({ userId }) {
  const dispatch = useDispatch();
  const [chatList, setchatList] = useState([]);
  const getUnreadReducer = useSelector((state) => state.getUnreadReducer);
  const getUnreadDatas = getUnreadReducer.unread;
  console.log(getUnreadReducer);
  useEffect(() => {
    firestore
      .collection("adminChatList")
      .orderBy("createdAt", "desc")
      .get()
      .then((data) => {
        const getList = data.docs.map((list) => list.data());
        setchatList(getList);
      });
  }, []);
  const handleClick = (user) => {
    dispatch({ type: "user_id", data: user });
    firestore
      .collection("customerMessages")
      .doc(user)
      .collection("messages")
      .get()
      .then((data) => {
        data.docs.map((id) => {
          firestore
            .collection("customerMessages")
            .doc(user)
            .collection("messages")
            .doc(id.id)
            .update({
              read: true,
              fromUser: user,
            })
            .then((data) => {
              window.location.href = "/adminMessage";
            });
        });
      });
  };

  return (
    <div>
      <ul style={{ listStyle: "none", padding: "0px" }}>
        {chatList &&
          chatList.map((list) => (
            <li
              key={list.newUser}
              style={{
                paddingTop: "15px",
                paddingBottom: "15px",
                paddingRight: "10px",
                paddingLeft: "10px",
                backgroundColor: "white",
                color: "#00AAEF",
                marginBottom: "10px",
                width: "100%",
                cursor: "pointer",
              }}
              onClick={() => handleClick(list.newUser)}
            >
              {list.newUser}
            </li>
          ))}
      </ul>
    </div>
  );
}
